import Footer from './Footer';
import Header from './Header';
import Hero from './Hero';
import HeroPlain from './HeroPlain';
import Features, {Feature} from './Features';
import Pricing from './Pricing';
import SignupDivider from './SignupDivider';
import TextPage from './TextPage';
import References, {Reference} from './References';
import BookDemo from './BookDemo';
import Video from './Video';
import FeaturedIn from './FeaturedIn';
import FeatureTestimonial from './FeatureTestimonial';
import Signup from './Signup';
import GetStarted from './GetStarted';
import DownloadCTA from './DownloadCTA';
import VideoSection from './VideoSection';
import Partner from './Partner';
import Bio from './Bio';
import Location from './Location';
import SEO from './SEO';

export {
    Footer,
    Header,
    Hero,
    Location,
    HeroPlain,
    Features,
    Feature,
    Pricing,
    SignupDivider,
    TextPage,
    References,
    Reference,
    BookDemo,
    Video,
    FeaturedIn,
    Partner,
    FeatureTestimonial,
    Signup,
    DownloadCTA,
    GetStarted,
    VideoSection,
    Bio,
    SEO
};
